/* Profile's parts for Accelerator members (Account.dc.html): Change photo beside the ring, the photo
   in the ring, About you's box and the member directory switch, in the board's sizes and the master
   brand's tokens only (tokens.css). Account's own styles are src/styles/account.css. */
.ac-photo--img { overflow: hidden; }
.ac-photo--img img { width: 100%; height: 100%; object-fit: cover; }
.ac-photo-change { display: flex; align-items: center; gap: 14px; flex-wrap: wrap; min-width: 0; }
.ac-btn.ac-photo-btn { height: 40px; padding: 0 16px; }
.ac-photo-input { position: absolute; width: 1px; height: 1px; opacity: 0; pointer-events: none; }
.ac-input.ac-textarea { height: 96px; padding: 12px 14px; line-height: 1.5; resize: none; font: inherit; font-size: 16px; }
.ac-switch-row {
  display: flex; align-items: center; justify-content: space-between; gap: 20px; padding: 14px 16px; border-radius: 12px;
  border: 1px solid var(--shell-ink-12); background: transparent; color: var(--shell-ink); text-align: left; width: 100%;
}
.ac-switch-row:disabled { cursor: default; }
/* a member of 2 masterminds or more: a switch for each, close together (the product-types follow-ups, 13 Oct) */
.ac-switches { display: flex; flex-direction: column; gap: 10px; min-width: 0; }
.ac-switch-label { font-size: 15px; font-weight: 600; }
.ac-toggle { width: 48px; height: 28px; border-radius: 14px; background: var(--shell-ink-20); position: relative; flex-shrink: 0; }
.ac-toggle--on { background: var(--shell-ink); }
.ac-toggle-knob { position: absolute; top: 3px; left: 3px; width: 22px; height: 22px; border-radius: 11px; background: var(--shell-bg); }
.ac-toggle--on .ac-toggle-knob { left: 23px; }

@media (max-width: 760px) {
  .ac-photo-change { flex-direction: column; align-items: flex-start; gap: 8px; }
  .ac-btn.ac-photo-btn { width: auto; }
}
